export default "__VITE_ASSET__813fed85__"